// Counts the amount of times that the script was loaded
// For now, used to indicate which version of the drawer (minimized/open) to show
import { writable, type Writable } from "svelte/store"

const storedTimesLoaded: string | null =
  sessionStorage.getItem("auwsTimesLoaded")

export const timesLoaded: Writable<number> = writable(
  storedTimesLoaded ? parseInt(storedTimesLoaded) : 0
)

timesLoaded.subscribe((value: number) => {
  const stringValue = value.toString()
  sessionStorage.setItem("auwsTimesLoaded", stringValue)
})
